import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import { FaRegListAlt } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import { BsFillCheckCircleFill } from "react-icons/bs";
// import Table from "../../components/UserDashboard/Table";
import { MdAssignment, MdCancel } from "react-icons/md";
// import Promos from "../../components/UserDashboard/Promos";
import { useDispatch, useSelector } from "react-redux";
// import { getAllOrdersAction } from "../../Redux/Actions/OrderAction";
import { toast } from "react-toastify";
// import orderData from "./data";
// import bookingApi from "../../api/booking/BookingApi";
// import Loading from "../../Util/Loading";
import { HiOutlineClock } from "react-icons/hi";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { MdCalendarToday } from "react-icons/md";
import Loading from "components/Loading/Loading";
import SidebarMenu from "./SideBarMenu";
import Table from "components/Table/Table";
import { Empty } from "shared/Notifications/Error";
import ChartDashboard from "./components/Chart";
import TaskDistributionWidget from "./components/TaskDistributionWidget";
import ScheduleWidget from "./components/ScheduleWidget";
import bookingApi from "api/booking/BookingApi";
import { getAllOrdersService } from "api/order/OrderApi";
import SummaryCardGrid from "./components/SummaryCardGrid";

function Dashboard() {
  const dispatch = useDispatch();
  const [booking, setBooking] = useState([]);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const user = useSelector((state) => state.auth.user);

  const getAllBookings = async () => {
    try {
      const { response, err } = await bookingApi.getAllBookings();

      if (response && response.data) {
        setBooking(response.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getAllOrders = async () => {
    try {
      const data = await getAllOrdersService();
      setOrders(data || []);
    } catch (error) {
      toast.error("Failed to fetch orders");
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getAllBookings(), getAllOrders()]);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  if (isLoading) return <Loading />;

  const now = new Date();

  // console.log({ orders });
  // console.log({ booking });

  // Destructure order summary safely
  const {
    orders: orderList = [],
    total: totalOrders = 0,
    completed: completedOrders = 0,
    pending: pendingOrders = 0,
    cancelled: cancelledOrders = 0,
  } = orders || {};

  // Destructure booking summary safely
  const {
    booking: bookingList = [],
    total: totalBookings = 0,
    booked: upcomingBookings = 0,
    cancelled: cancelledBookings = 0,
  } = booking || {};

  const orderCards = [
    {
      title: "Total Orders",
      count: totalOrders,
      sub: "All customer orders",
      color: "text-yellow-500",
    },
    {
      title: "Pending Orders",
      count: pendingOrders,
      sub: "Waiting for payment",
      color: "text-orange-500",
    },
    {
      title: "Completed Orders",
      count: completedOrders,
      sub: "Successfully paid",
      color: "text-green-500",
    },
    {
      title: "Cancelled Orders",
      count: cancelledOrders,
      sub: "User cancelled",
      color: "text-red-500",
    },
  ];

  const bookingCards = [
    {
      title: "Total Bookings",
      count: totalBookings,
      sub: "All booking records",
      color: "text-yellow-500",
    },
    {
      title: "Upcoming Bookings",
      count: upcomingBookings,
      sub: "Still scheduled",
      color: "text-blue-500",
    },
    {
      title: "Cancelled Bookings",
      count: cancelledBookings,
      sub: "Cancelled by user or admin",
      color: "text-red-500",
    },
    {
      title: "Completed Bookings",
      count: bookingList.filter((b) => b?.booking?.status === "completed")
        .length,
      sub: "Finished appointments",
      color: "text-green-500",
    },
  ];

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="bg-gray-900 text-white min-h-screen pb-8 pt-4 lg:pt-12 px-0 lg:px-4">
      <div className="container mx-auto px-2">
        <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-6">
          <div className="hidden md:block sticky col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5">
            <SidebarMenu />
          </div>

          <div
            data-aos="fade-up"
            className="col-span-6 rounded-md bg-gray-800 p-6"
          >
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4 md:gap-0">
              <div>
                <h2 className="text-xl font-semibold">
                  Welcome back, {user?.displayName}
                </h2>
                <p className="text-sm text-gray-400">
                  You have total{" "}
                  <span className="text-redlight ">{totalBookings}</span> books
                  and <span className="text-redlight ">{totalOrders}</span>{" "}
                  orders
                </p>
              </div>
              <div className="flex gap-2">
                <button className="bg-red-500 text-white px-3 py-1 rounded">
                  Messages
                </button>
                <button className="border border-red-500 text-red-500 px-3 py-1 rounded">
                  Settings
                </button>
              </div>
            </div>
            <h2 className="text-xl font-bold mb-4">Dashboard</h2>

            {/* Orders Section */}
            <div>
              <h3 className="text-lg font-semibold mb-2 text-red-500">
                🧾 Orders
              </h3>
              <SummaryCardGrid cards={orderCards} />
            </div>
            <div className="mb-6">
              <ChartDashboard orders={orders ?? []} />
            </div>

            {/* Bookings Section */}
            <div>
              <h3 className="text-lg font-semibold mb-2 text-blue-500">
                📅 Bookings
              </h3>
              <SummaryCardGrid cards={bookingCards} />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Left: Task Distribution */}
              <div className="bg-dry rounded-xl shadow p-0">
                <TaskDistributionWidget />
              </div>

              {/* Right: Schedule */}
              <div className="bg-dry rounded-xl shadow p-0">
                <ScheduleWidget />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
